// TODO: Generalize the pdf viewer.. It's not used just for properties. Move to own module
import { PDFViewer } from '@/pdf/components/pdf-viewer';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, Progress } from 'rsuite';
import styled from 'styled-components';
import { CitationPDFViewerHeader } from './citation-pdf-viewer-header';

const { Line } = Progress;

const CenteredModal = styled(Modal)`
  height: 100%;
  display: flex !important;
  align-items: center;
  width: 400px;

  .rs-modal-dialog {
    width: 400px;
  }
`;

const FIRST_PAGE_NUMBER = 1;

let timeoutId = null;

export function CitationPDFViewer(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [loaderCompleted, setLoaderCompleted] = useState(false);
  const [loaderPercentage, setLoaderPercentage] = useState(0);

  useEffect(() => {
    if (props.showPdfModal && !loaderCompleted) {
      if (loaderPercentage >= 100) {
        setTimeout(() => {
          setLoaderCompleted(true);
        }, 150);
      } else {
        timeoutId = setTimeout(() => {
          setLoaderPercentage(loaderPercentage + 1);
        }, 50);
      }
    }
  }, [
    loaderCompleted,
    loaderPercentage,
    props.showPdfModal,
    setLoaderPercentage,
  ]);

  const goToNextPage = useCallback(() => {
    setCurrentPage(currentPage + 1);
  }, [currentPage, setCurrentPage]);

  const goToPreviousPage = useCallback(() => {
    if (currentPage > FIRST_PAGE_NUMBER) {
      setCurrentPage(currentPage - 1);
    }
  }, [currentPage, setCurrentPage]);

  const headerProps = {
    onCancelClick: () => {
      // FIXME: Hack for demo only.. shouldn't be like this
      setLoaderCompleted(false);
      props.closePdfModal();
      clearTimeout(timeoutId);
      setLoaderPercentage(0);
    },
    nextPage: goToNextPage,
    previousPage: goToPreviousPage,
    currentPage,
  };

  return (
    <>
      <PDFViewer
        // TODO: fix hack in line below
        closePdfModal={headerProps.onCancelClick}
        showPdfModal={props.showPdfModal && loaderCompleted}
        currentPage={currentPage}
        headerComponent={CitationPDFViewerHeader}
        headerProps={headerProps}
        pdfFilePath="https://public-rentalscape-demo-items.s3.us-east-2.amazonaws.com/IB_sample_notice_all.pdf"
      />
      <CenteredModal size="sm" open={props.showPdfModal && !loaderCompleted}>
        <Modal.Header>
          <div
            css={`
              font-size: 16px;
              font-weight: 700;
              line-height: 1;
              color: rgba(0, 0, 0, 0.85);
            `}
          >
            Generating Citation Letters
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            css={`
              font-size: 14px;
              line-height: 1.57;
              color: rgba(0, 0, 0, 0.85);
            `}
          >
            Please wait while letters are generated.
          </div>
          <Line percent={loaderPercentage} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={headerProps.onCancelClick}>Cancel</Button>
        </Modal.Footer>
      </CenteredModal>
    </>
  );
}
